import React, { useEffect } from "react";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { LayoutForLandingPage } from "./Home";

const Blogs = () => {
  const [activeSection, setActiveSection] = React.useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="flex flex-col justify-center gap-2 mt-20">
      <h1 className="text-[40px] items-center font-semibold flex justify-center mt-4">
        Blogs
      </h1>
      <LayoutForLandingPage>
        <div className="max-w-7xl mx-auto p-6 mb-8 bg-white ">
          <header className=" text-center py-4 rounded-t-lg">
            {!activeSection && (
              <h1 className="text-3xl text-[#F66] font-bold mb-2">
                {/* Top 4 Ways a Highly Efficient Mom Uses AI */} Coming Soon
              </h1>
            )}
          </header>
          <div className="max-w-7xl mb-4 min-h-[400px]">
            {/* <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 w-full">
              {!activeSection &&
                blogContent.map((section) => (
                  <div
                    key={section.id}
                    className="relative group cursor-pointer"
                    onClick={() => {
                      // handleClick(section.id);
                      // setData(section);
                      redirect(`/blogs/${section.id}`);
                    }}
                  >
                    <img
                      src={section.image}
                      alt="Blog"
                      className="rounded-md border-2 p-2 w-full h-64 object-cover"
                    />
                    <h2 className="text-[#2F3649] text-2xl font-semibold mt-2 group-hover:text-[#F66]">
                      {section.title}
                    </h2>
                  </div>
                ))}{" "}
            </div> */}
          </div>
        </div>
      </LayoutForLandingPage>
      <Footer />
    </div>
  );
};

export default Blogs;
